import {ActionButton, DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {Permission} from "../../../app/Login/_guards/Permission";
import {dateTimeStringToFormattedDate} from "../../Utility/DateUtility";
import {DynamicListComponent} from "../../../app/shared/dynamic-list/dynamic-list.component";
import {forkJoin} from "rxjs";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {GetFromLocalStorage, SaveToLocalStorage} from "../../Utility/Utility";
import {GetCarrello, GetCarrelloCount, GetCarrelloVoci, getSpedizione, PrezzoIvato} from "./ProductUtility";
import {data} from "jquery";
import {DateToString, Oggi, OggiPlus} from "../../Utility/DateUtility";
import {getOrdineDefaultSave} from "./Ordini_Ricevuti";
import {GlobalStoreService} from "../../../app/shared/_services/global-store.service";

function I_miei_Ordini() {
  var OBJ: OggettoConfig = {
    Id: "orders",
    DisableEdit: true,
    campi: [
      {
        class: 'col-12',
        nome: "",
        type: 'Tabs',
        DisableEdit: true,
        hideif: {func: (x) => !x.id},
        TabSettings: {
          CrudSettings: (x) => {
            return {ConcatParams: {}, filtro: {}}
          },
          defaultTab: (x) => 'CR'
        },
        tabs: [
          ...Tabs().reduce((acc, tab) => [...acc, {
            id: tab.stato,
            titolo: tab.nome,
            tipo: 'campi',
            campi: [
              CampoAggiuntivo.Crud(
                "",
                Ordini(tab.stato),
                {
                  prevDivClass: 'col-lg-12',
                  class: 'col-12 ',
                  hideif: {func: (x, permission: Permission) => permission.isOperativeRoles(['C'])}
                }
              ),
              CampoAggiuntivo.Crud(
                "",
                Ordini(tab.stato, {Id: `ordini_${tab.stato}_persona`, RestRoute: "/progetti/ordini"}),
                {
                  prevDivClass: 'col-lg-12',
                  class: 'col-12 ',
                  hideif: {func: (x, permission: Permission) => permission.isntOperativeRoles(['C'])}
                }
              )
            ]
          }], []),
        ]
      }
    ],
    MenuItems: [

      {
        path: 'shared/dynamicedit/orders',
        title: "I miei Ordini",
        icon: "fas fa-cart",
        class: "",
        capacita: [],
      }
    ]
  }
  return OBJ;
}

function getPrice(ordine: any) {
  return ordine.progetti?.reduce((acc, progetto) => acc + progetto.voci.reduce((acc, voce) => acc + ((PrezzoIvato(voce.prezzo, 22) ?? 0) * (voce.quantita ?? 1)), 0), 0) + GetSpedizione(ordine) ?? 'Error';
}

export function getOrderStatus(ordine): 'da_confermare' | 'confermato' | 'pagato' | 'spedito' | 'consegnato' | 'annullato' | string {
  var stato: 'da_confermare' | 'confermato' | 'pagato' | 'spedito' | 'consegnato' | 'annullato' = undefined;

  if (ordine.data_creazione)
    stato = 'da_confermare';
  if (ordine.data_creazione && ordine.dataDisponibilita)
    stato = 'confermato';
  if (ordine.data_conferma)
    stato = 'pagato';
  if (ordine.annullato)
    stato = 'annullato';
  return stato ?? ordine.stato;
}

function getOrderStatusHtml(ordine) {
  var status = getOrderStatus(ordine);
  if (status == 'da_confermare')
    return '<div class="acq-status elaborazione">⏳ In attesa di conferma dal venditore</div>';
  if (status == "confermato")
    return '<div class="acq-status arrivo">✅ Confermato — procedi al pagamento</div>';
  if (status == "preparazione")
    return '<div class="acq-status arrivo">📦 In preparazione</div>';
  if (status == 'spedito')
    return '<div class="acq-status arrivo">🚚 Spedito</div>';
  if (status == 'consegnato')
    return '<div class="acq-status consegnato">✓ Consegnato</div>';
  if (status == 'annullato')
    return '<div class="acq-status elaborazione">✕ Annullato</div>';
  return `<div class="acq-status consegnato">${status}</div>`
}

function getOrderStatusSubHtml(ordine) {
  var status = getOrderStatus(ordine);
  if (status == 'da_confermare')
    return '<div class="acq-status-sub">Il venditore risponderà entro 48h. L\'importo non è ancora addebitato.</div>';
  if (status == "confermato")
    return '<div class="acq-status-sub">Il venditore ha confermato la disponibilità. Completa il pagamento per procedere.</div>';
  if (status == "preparazione")
    return '<div class="acq-status-sub">Il tuo ordine è in preparazione presso il venditore.</div>';
  if (status == 'spedito')
    return `<div class="acq-status-sub">In transito · Tracking: <strong>${'Inserire il tracking'}</strong></div>`;
  if (status == 'consegnato')
    return '<div class="acq-status-sub">Ordine consegnato con successo.</div>';
  return ``
}


function DettaglioOrdineHtml(ordine, parent) {
  return `
      <div class="acq-card-body">
        <div class="acq-item-row">

          <div class="acq-item-info">
            ${getOrderStatusHtml(ordine)}
            ${getOrderStatusSubHtml(ordine)}
            <div class="dettaglio" >
            ${ordine?.progetti?.reduce((acc, progetto) => acc + progetto.voci.reduce((acc, voce) => acc + `
             <div class="dettaglio-prodotto" >
             <div class="acq-item-img "><img class="d-gal-img" src="${parent.apiPaths.getBaseAPI()}/file/image/${voce.id_immagine}"></div>
             <div class="info-prodotto">
                <div class="nome-prodotto">${voce.voce}</div>
                <div class="taglie">
  ${voce.tagliaObject?.taglia ?? 'taglia non definita'} · ${voce.coloreObject?.map(c => c.check).join(', ') ?? 'colore non definito'}
</div>
${getVoceImportoHtml(voce)}
              </div>
              </div>
            `, ''), '')}

            </div>

          </div>
        </div>
      </div>
      `
}

function GetSpedizione(ordine) {
  var prod = GetCarrelloVoci([ordine])?.map(x => ({prodotto_cart: x, prodotto: x.prodottoObject}))
  console.log(prod);
  var sped = getSpedizione({esclusiva: ordine.esclusivaObject, items: prod}, ordine.percSpedizione, ordine.costoSpedizione)
  console.log(sped);

  return sped ?? 0;
}
function getTotaleProdotti(ordine: any) {
  return ordine.progetti?.reduce((acc, progetto) =>
      acc + (progetto.voci?.reduce((acc2, voce) => {

        const iva = Number(voce.iva ?? 22);
        const quantita = Number(voce.quantita ?? 1);
        const sconto = Number(voce.sconto ?? 0);

        const prezzoIvato = PrezzoIvato(voce.prezzo, iva) ?? 0;

        const prezzoFinale = sconto > 0
          ? prezzoIvato - ((prezzoIvato / 100) * sconto)
          : prezzoIvato;

        return acc2 + (prezzoFinale * quantita);

      }, 0) ?? 0)
    , 0) ?? 0;
}
function HeaderCard() {
  return [
    CampoAggiuntivo.Html("", (x) => `
      <div class="acq-card-header">
        <div>
          <span class="acq-hd-lbl">N° ordine</span>
          <span class="acq-hd-val n-ordine" >${x.progressivo}</span>
        </div>
        <div>
          <span class="acq-hd-lbl">Prenotato il</span>
          <span class="acq-hd-val">${dateTimeStringToFormattedDate(x.data_creazione)}</span>
        </div>
        <div>
          <span class="acq-hd-lbl">Totale Ordine</span>
          <span class="acq-hd-val">€${getTotaleProdotti(x).toDecimals(2)}</span>
        </div>
        <div>
          <span class="acq-hd-lbl">Spedizione</span>
          <span class="acq-hd-val"> €${GetSpedizione(x).toDecimals(2)}</span>
        </div>
        <div>
          <span class="acq-hd-lbl">Negozio</span>
          <span class="acq-hd-val negozio">${x.oggetto}</span>
        </div>

      </div>
      `, () => true, {class: 'col-lg-12'}),
    CampoAggiuntivo.Html("", DettaglioOrdineHtml, () => true, {class: 'col-lg-12'})
  ]
}

function Tabs(): { nome: string, stato: string }[] {
  return [
    {nome: '⏳ In attesa conferma', stato: 'CR'},
    {nome: '✔ Confermati', stato: 'DI'},
    {nome: '📦 Storico ordini', stato: 'CO'}
  ]
}


export function Ordini(stat?: string, altro?: OggettoConfig) {
  var stato: string = stat ?? 'T';
  var OBJ: OggettoConfig = {
    Id: `ordini_${stato}`,
    listView: 'card',
    listClass: 'vw50list',
    cardPerRow: 1,
    RestRoute: '/progetti/ordini',
    ListDefaultFilter: {stato_ord: stato, periodo: false, annullato: false},
    cardClass: 'card-small card-order',
    asyncFullResponseMap: (response: any | any[], component: DynamicListComponent, callBack: (response) => any) => {
      console.log("Response", response)
      if (!response?.data?.length) {

        response.data = [];

        callBack(response);

        return;

      }
      component.api.ClassicGet("/progetti/costi/spedizione").subscribe((res:{id:number, check:string, codice:string}[]) => {
        console.log("spedizione get", res);
        var costoFisso = res.filter(x=>x.id==5).reduce((a, b) => a + parseFloat(b.codice), 0);
        console.log("costo Fisso Spedizione: ", costoFisso);
        var perc = res.filter(x=>x.id==6).reduce((a, b) => a + parseFloat(b.codice), 0);
        console.log("% Maggiorazione Spedizione", perc);
        var requests = response?.data?.map(x => component.api.ClassicPost(`${altro?.RestRoute ?? '/progetti/ordini'}/get`, {id: x.id}))
        forkJoin(requests).subscribe((data: { data: any[], stampe: any[] }[]) => {
          response.data = data.reduce((acc, x) => acc.concat({...x.data, costoSpedizione: costoFisso, percSpedizione: perc}), []);
          callBack(response)
        })
      })

    },
    ListResponseHasData: true,
    PrintHeaders: [],
    Headers: [
      ...HeaderCard()
    ],
    Filters: [
      /*CampoAggiuntivo.TextField("Cerca nei tuoi ordini", "prodotto", 'col-lg-3', {}),*/
      CampoAggiuntivo.SingleDropdown(
        "",
        'filtroPeriodo',
        [
          {id: null, label: 'Tutti gli ordini'},

          {id: '30', label: 'negli ultimi 30 giorni'},

          {id: '90', label: 'ultimi 3 mesi'},

          ...Array.from(
            {
              length:
                (new Date().getFullYear() - 2022) + 1
            },
            (_, i) => {

              const year =
                new Date().getFullYear() - i;

              return {
                id: `${year}`,
                label: `nel ${year}`
              };

            }
          )
        ],
        'label',
        {
          class: 'col-lg-3',
          OnChangeFunc: (x, selected, api, toast, oggetto) => {
            console.log("X", x);

            console.log("OGGETTO", oggetto);
            x.periodo = false;
            x.page = 0;
            delete x.inizio;
            delete x.fine;
            if (!x.filtroPeriodo) {
              delete x.inizio;
              delete x.fine;
              x.periodo = false;
              return;
            }
            const oggi = new Date();
            if (x.filtroPeriodo === '30') {
              const inizio = new Date();
              inizio.setDate(oggi.getDate() - 30);
              x.inizio = DateToString(inizio);
              x.fine = DateToString(oggi);
            } else if (x.filtroPeriodo === '90') {
              const inizio = new Date();
              inizio.setMonth(oggi.getMonth() - 3);
              x.inizio = DateToString(inizio);
              x.fine = DateToString(oggi);

            } else {
              x.inizio = `${x.filtroPeriodo}-01-01`;
              x.fine = `${x.filtroPeriodo}-12-31`;
            }

            x.periodo = !!(x.inizio?.length && x.fine?.length);
            console.log("FILTRO FINALE", x);
          }
        }
      ),

    ],
    AzioniLista: [
      {
        nome: 'Annulla Prenotazione',
        close: false,
        icon: '',
        class: ' btn  acq-btn-action',
        single: true,
        labelClass: ' ',
        type: 'func',
        hideif: {func: (x) => !x.data_emissione && !x.annullato},
        func: AnnullaOrdine
      },
      {
        nome: '💳 Procedi al pagamento',
        close: false,
        icon: '',
        class: ' btn  paga-button',
        single: true,
        labelClass: ' ',
        type: 'func',
        hideif: {func: (x) => x.data_emissione && !x.annullato},
        func: PagaOrdine,

      },
      {
        nome: 'Aggiungi al carrello',
        close: false,
        icon: '',
        noGet: true,
        class: ' btn  acq-btn-action green-border',
        single: true,
        labelClass: ' ',
        type: 'func',
        hideif: {func: (x, permission, store: GlobalStoreService) => x.data_emissione && !x.annullato && !store?.CartData?.dataCarrello?.find(y => y.id == x.id)},
        func: AggiungiAlCarrello,
        style: {
          'border-color': '#0F766E ',
          'color': '#0F766E'
        }
      },
      {
        nome: 'Rimuovi dal carrello',
        close: false,
        icon: '',
        noGet: true,
        class: ' btn  acq-btn-action red-border',
        single: true,
        labelClass: ' ',
        type: 'func',
        hideif: {func: (x, permission, store: GlobalStoreService) => x.data_emissione && !x.annullato && store?.CartData?.dataCarrello?.find(y => y.id == x.id)},
        func: RimuoviDalCarrello,
        style: {
          'border-color': '#ff0000 ',
          'color': '#ff0000'
        }
      },
      {
        nome: 'Annulla',
        close: false,
        icon: '',
        class: ' btn  acq-btn-action',
        single: true,
        labelClass: ' ',
        type: 'func',
        hideif: {func: (x) => x.data_emissione && !x.annullato},
        func: AnnullaOrdine
      },

    ],
    ...altro ?? {}

  }
  return OBJ;
}

function AnnullaOrdine(x: any, api: ApiPathsService, onEnd: () => void, Toastr: ToastrService, component: DynamicCrudService) {
  if (!confirm("Sei sicuro di voler annullare l'ordine?")) return;
  x = getOrdineDefaultSave(x);
  x.annullato = true;
  x.progetti.forEach(progetto => {
    progetto.annullato = true;
  })
  api.ClassicPost("/progetti/ordini/update", x).subscribe(x => {
    api.toastService.success("Ordine annullato con successo", "Ordine annullato", {toastClass:'marketplace-success-toast'});
    if (onEnd)
      onEnd();
  })

}

function PagaOrdine(field: any, api: ApiPathsService, onEnd: () => void, Toastr: ToastrService, component: DynamicCrudService) {

}

function AggiungiAlCarrello(field: any, api: ApiPathsService, onEnd: () => void, Toastr: ToastrService, component: DynamicCrudService) {
  // var carrello = GetCarrello()
  // carrello.push(field);
  // SaveToLocalStorage('carrello', carrello);
  api.ClassicPost('/progetti/ordini/carrello/add', {id: field.id}).subscribe(data=>{
    component.store.getCartData();
    Toastr.success('Ordine aggiunto al carrello', '', {toastClass:'marketplace-success-toast'});
    console.log("Ordine aggiunto al carrello", field, GetFromLocalStorage('carrello'), "Voci Count: ", GetCarrelloCount(component.store));
  })

}

function RimuoviDalCarrello(field: any, api: ApiPathsService, onEnd: () => void, Toastr: ToastrService, component: DynamicCrudService) {
  // var carrello = GetCarrello()
  // var index = carrello.findIndex(x => x.id == field.id);
  // carrello.splice(index, 1);
  // SaveToLocalStorage('carrello', carrello);

  api.ClassicPost('/progetti/ordini/carrello/delete', {id: field.id}).subscribe(data=>{
    component.store.getCartData();
  Toastr.success('Ordine Rimosso dal carrello', '',{toastClass:'marketplace-success-toast'});
  console.log("Ordine rimosso dal carrello", field, GetFromLocalStorage('carrello'), "Voci Count: ", GetCarrelloCount(component.store));
  });

}

function getVocePrezzoHtml(voce: any) {
  const iva = Number(voce.iva ?? 22);
  const quantita = Number(voce.quantita ?? 1);

  const prezzoNetto = Number(voce.prezzo ?? 0);
  const sconto = Number(voce.sconto ?? 0);

  const prezzoInteroIvato = PrezzoIvato(prezzoNetto, iva) ?? 0;

  const prezzoScontatoIvato = sconto > 0
    ? prezzoInteroIvato - ((prezzoInteroIvato / 100) * sconto)
    : prezzoInteroIvato;

  const importoIntero = prezzoInteroIvato * quantita;
  const importoScontato = prezzoScontatoIvato * quantita;

  if (!sconto) {
    return `
      <div class="spese">
        Prezzo: €${prezzoInteroIvato.toDecimals(2)}
        · Importo: €${importoIntero.toDecimals(2)}
      </div>
    `;
  }

  return `
  <div class="spese">
    Prezzo:
    <span class="ordine-old">€${prezzoInteroIvato.toDecimals(2)}</span>

    <span class="ordine-promo-badge">
      -${sconto}%
    </span>

    <span class="ordine-price">
      €${prezzoScontatoIvato.toDecimals(2)}
    </span>

    · Importo:

    <span class="ordine-old">
      €${importoIntero.toDecimals(2)}
    </span>

    <span class="ordine-price">
      €${importoScontato.toDecimals(2)}
    </span>
  </div>
`;
}

function getVocePrezzoSingoloHtml(voce: any) {
  const p = getVocePrezzoValues(voce);

  if (!p.sconto) {
    return `
      <span class="ordine-single-price">
        Prezzo: <span class="ordine-price">€${p.prezzoInteroIvato.toDecimals(2)}</span>
      </span>
    `;
  }

  return `
    <span class="ordine-single-price">
      Prezzo:
      <span class="ordine-old">€${p.prezzoInteroIvato.toDecimals(2)}</span>
      <span class="ordine-promo-badge">-${p.sconto}%</span>
      <span class="ordine-price">€${p.prezzoScontatoIvato.toDecimals(2)}</span>
    </span>
  `;
}

function getVocePrezzoValues(voce: any) {
  const iva = Number(voce.iva ?? 22);
  const quantita = Number(voce.quantita ?? 1);

  const prezzoNetto = Number(voce.prezzo ?? 0);
  const sconto = Number(voce.sconto ?? 0);

  const prezzoInteroIvato = PrezzoIvato(prezzoNetto, iva) ?? 0;

  const prezzoScontatoIvato = sconto > 0
    ? prezzoInteroIvato - ((prezzoInteroIvato / 100) * sconto)
    : prezzoInteroIvato;

  return {
    quantita,
    sconto,
    prezzoInteroIvato,
    prezzoScontatoIvato,
    importoIntero: prezzoInteroIvato * quantita,
    importoScontato: prezzoScontatoIvato * quantita
  };
}

function getVoceImportoHtml(voce: any) {
  const p = getVocePrezzoValues(voce);

  if (!p.sconto) {
    return `
      <div class="spese ordine-importo-row">
        <span>Qtà: ${p.quantita}</span>
        <span>
          Importo:
          <span class="ordine-price">€${p.importoIntero.toDecimals(2)}</span>
        </span>
      </div>
    `;
  }

  return `
  <div class="spese ordine-importo-row">
    <span>Qtà: ${p.quantita}</span>
    <span>
      Importo:
      <span class="ordine-old">€${p.importoIntero.toDecimals(2)}</span>
      <span class="ordine-promo-badge">-${p.sconto}%</span>
      <span class="ordine-price">€${p.importoScontato.toDecimals(2)}</span>
    </span>
  </div>
`;
}

export var I_miei_OrdiniEnv = () => {
  var env: any = {
    Modules: {
      "I miei Ordini": true
    },
    Cruds: [
      I_miei_Ordini(),
      ...Tabs().reduce((acc, tab) => [...acc, Ordini(tab.stato), Ordini(tab.stato, {
        Id: `ordini_${tab.stato}_persona`,
        RestRoute: "/progetti/ordini"
      })], []),
    ],
    Menu: [...I_miei_Ordini().MenuItems]
  }
  return env;

}
